/*首页功能相关路由*/
const gxsfb_cockpit = () =>  import("../../../studio/new_cockpit_box/cockpit_children/gxsfb_cockpit/gxsfbCockpitBoxMain");

export default [
  {
    path: '/gxsfb_cockpit',
    name: '供应商驾驶舱',
    component: gxsfb_cockpit
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/gxsfb/gxsfb_cockpit_page.js